import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AnnouncementBar from './components/AnnouncementBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ImpactMetrics from './components/ImpactMetrics';
import WhyItWorks from './components/WhyItWorks';
import Features from './components/Features';
import Interfaces from './components/Interfaces';
import Integrations from './components/Integrations';
import PoweredByFluidWeb from './components/PoweredByFluidWeb';
import AdvancedCapabilities from './components/AdvancedCapabilities';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FluidFormPreview from './pages/FluidFormPreview';
import TryFluidForm from './pages/TryFluidForm';
import ChatBubble from './components/ChatBubble';
import VerticalB from './pages/VerticalB';
export function App() {
  useEffect(() => {
    // Preconnect to external domains for faster resource loading
    const preconnectDomains = ['https://uploadthingy.s3.us-west-1.amazonaws.com', 'https://cdn.magicpatterns.com', 'https://app.fluid-form.ai', 'https://accounts.fluid-form.ai', 'https://www.googletagmanager.com'];
    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
    // Google Analytics (gtag.js)
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-9F433GY2HD';
      document.head.appendChild(gtagScript);
      const gtagInit = document.createElement('script');
      gtagInit.textContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-9F433GY2HD');
      `;
      document.head.appendChild(gtagInit);
    }
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/terms" element={<TermsOfUse data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/preview" element={<FluidFormPreview data-id="element-7" />} data-id="element-6" />
        <Route path="/try" element={<TryFluidForm data-id="element-9" />} data-id="element-8" />
        <Route path="/b" element={<VerticalB data-id="element-11" />} data-id="element-10" />
        <Route path="/" element={<div className="w-full min-h-screen font-sans" data-id="element-13">
              <div className="sticky top-0 z-50" data-id="element-14">
                <AnnouncementBar data-id="element-15" />
                <Navbar data-id="element-16" />
              </div>
              <Hero data-id="element-17" />
              <ImpactMetrics data-id="element-18" />
              <WhyItWorks data-id="element-19" />
              <Features data-id="element-20" />
              <Interfaces data-id="element-21" />
              <Integrations data-id="element-22" />
              <PoweredByFluidWeb data-id="element-23" />
              <AdvancedCapabilities data-id="element-24" />
              <Pricing data-id="element-25" />
              <FAQ data-id="element-26" />
              <CTA data-id="element-27" />
              <Footer data-id="element-28" />
            </div>} data-id="element-12" />
      </Routes>
      <ChatBubble data-id="element-29" />
    </BrowserRouter>;
}